<template>
  <div class="Profile__General__Page">
    <div class="Profile__General__Page__Header">
      <h1>הגדרות פרופיל</h1>
    </div>
    <div class="Profile__General__Page__Form">
      <div style="display: flex; gap: 20px" class="Profile__General__Page__Form__Field">
        <b-field label="פרופיל מנוהל">
          <b-switch v-model="model.IsManaged" @input="onChangeActive">
            {{ model.IsManaged ? "כן" : "לא" }}
          </b-switch>
        </b-field>
        <b-field v-if="isAdmin" label="הסבה לילית">
          <b-switch :disabled="!model.IsManaged" v-model="IsOnNightRunning" @input="onChangeNightRunning">
            {{ IsOnNightRunning ? "כן" : "לא" }}
          </b-switch>
        </b-field>
        <b-field v-if="isAdmin" label="אפשר ייבוא מריפורט">
          <b-switch :disabled="!model.IsManaged" v-model="model.AllowRePortImport" @input="onChangeAllowRePortImport">
            {{ AllowRePortImport ? "כן" : "לא" }}
          </b-switch>
        </b-field>
        <b-field v-if="isAdmin" label="אל תציג לשונית חוזים חסרים">
          <b-switch :disabled="!model.IsManaged" v-model="model.DontShowMissingContractsTab" @input="onChangeDontShowMissingContractsTab">
            {{ DontShowMissingContractsTab ? "כן" : "לא" }}
          </b-switch>
        </b-field>
        <b-field v-if="isAdmin" label="חברת ליסינג">
          <b-switch v-model="model.IsLeasingCompany" @input="onChangeIsLeasingCompany">
            {{ model.IsLeasingCompany ? "כן" : "לא" }}
          </b-switch>
        </b-field>
        <b-field v-if="isAdmin" label="אפשר שינוי ידני ללקוח">
          <b-switch :disabled="!model.IsManaged" v-model="model.AllowManualChangeMenu" @input="onChangeAllowManualChangeMenu">
            {{ AllowManualChangeMenu ? "כן" : "לא" }}
          </b-switch>
        </b-field>
        <b-field v-if="isAdmin" label="שימוש בתאריך תוקף">
          <b-switch :disabled="!model.IsManaged" v-model="model.UsesValidDate" @input="onChangeUsesValidDate">
            {{ UsesValidDate ? "כן" : "לא" }}
          </b-switch>
        </b-field>
        <b-field v-if="isAdmin" label="הצגת דוח מלא ללקוח">
          <b-switch :disabled="!model.IsManaged" v-model="model.AllowClientFullReportVisibility" @input="onChangeAllowClientFullReportVisibility">
            {{ AllowClientFullReportVisibility ? "כן" : "לא" }}
          </b-switch>
        </b-field>
        <b-field v-if="isAdmin">
          <template #label>
            מוקם בריפורט אונליין
            <b-tooltip label="פרימיום לא ישלח בכל מקרה" type="is-dark">
              <b-icon icon="information-outline" size="is-small" />
            </b-tooltip>
          </template>
          <b-switch :disabled="!model.IsManaged" v-model="model.IsLocatedInRePortOnline" @input="onChangeIsLocatedInRePortOnline">
            {{ IsLocatedInRePortOnline ? "כן" : "לא" }}
          </b-switch>
        </b-field>
        <div v-if="isAutomationLoading">
          <b-loading :is-full-page="false" v-model="isAutomationLoading" :can-cancel="false" />
        </div>
      </div>
      <div style="display: flex; gap: 20px" class="Profile__General__Page__Form__Field">
        <b-field v-if="isAdmin" label="פרופיל מנוהל באוטומציה">
          <b-switch :disabled="!model.IsManaged" v-model="model.IsInAutomation" @input="onChangeAutomation">
            {{ model.IsInAutomation ? "כן" : "לא" }}
          </b-switch>
        </b-field>
        <b-field v-if="isAdmin" label="פרופיל מנוהל במילאון">
          <b-switch :disabled="!model.IsManaged" v-model="model.IsInMileon" @input="onChangeIsInMileon">
            {{ IsInMileon ? "כן" : "לא" }}
          </b-switch>
        </b-field>
        <b-field v-if="isAdmin" label="פרופיל מנוהל במיתר">
          <b-switch :disabled="!model.IsManaged" v-model="model.IsInMeitar" @input="onChangeIsInMeitar">
            {{ IsInMeitar ? "כן" : "לא" }}
          </b-switch>
        </b-field>
      </div>
      <div class="Profile__General__Page__Form__Field">
         <b-field label="נבדק לאחרונה בתאריך">
           <!-- <b-input :readOnly="true" v-model="model.LastCheckDate"></b-input> -->
           <div
             style="display: flex; align-items: center; align-items: center; padding: 0 10px; direction: ltr; min-width: 144px; border: 1px solid #cbd6e2;">
             {{ parseDate(model.LastCheckDate) }}</div>
           <b-button @click="updateCheckDate" :loading="isUpdatingCheckDate" type="is-primary">עדכן</b-button>
         </b-field>
         <b-field v-if="isAdmin" label="תאריך התחלה">
           <b-datepicker
             v-model="model.StartDate"
             :disabled="!model.IsManaged"
             placeholder="בחר תאריך"
             icon-prev="chevron-right"
             icon-next="chevron-left"
             icon="calendar-today"
             locale="en-GB"
             :day-names="['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש']"
             :month-names="[
               'ינואר',
               'פברואר',
               'מרץ',
               'אפריל',
               'מאי',
               'יוני',
               'יולי',
               'אוגוסט',
               'ספטמבר',
               'אוקטובר',
               'נובמבר',
               'דצמבר',
             ]"
             close-on-click
             editable
             append-to-body
             @input="onStartDateChange"
             class="is-rtl"
             dir="rtl"
           >
           </b-datepicker>
           <b-button @click="saveStartDate" :loading="isSavingStartDate" type="is-primary">עדכן</b-button>
         </b-field>
        <b-field label="סיסמה למרכז הקנסות">
          <b-input type="password" v-model="model.FineCenterPassword" password-reveal>
          </b-input>
          <b-button @click="savePassword" :loading="isSavingPassword" type="is-primary">עדכן</b-button>
        </b-field>
      </div>

      <!-- App Keys CRUD (admin) -->
      <div v-if="isAdmin" class="Profile__General__Page__Form__Field">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
          <h3>מפתחות API</h3>
          <b-button v-if="!isLoadingKeys && appKeys.length === 0" type="is-primary" size="is-small" @click="openAddKey">הוסף מפתח</b-button>
        </div>
        <b-table
          :data="appKeys"
          :loading="isLoadingKeys"
          :bordered="true"
          :striped="true"
          :narrowed="false"
          :hoverable="false"
        >
          <b-table-column label="שם" field="Name" v-slot="props">
            {{ props.row.Name }}
          </b-table-column>
          <b-table-column label="מייל" field="Email" v-slot="props">
            {{ props.row.Email }}
          </b-table-column>
          <b-table-column label="אפליקציות" field="AppName" v-slot="props">
            {{ props.row.AppName }}
          </b-table-column>
          <b-table-column label="API KEY" field="ApiKey" centered v-slot="props">
            <b-input readonly style="max-width: 230px;" type="password" :value="props.row.ApiKey" password-reveal />
          </b-table-column>
          <b-table-column label="SECRET KEY" field="ApiSecret" centered v-slot="props">
            <b-input readonly style="max-width: 230px;" type="password" :value="props.row.ApiSecret" password-reveal />
          </b-table-column>
          <b-table-column label="פעיל" field="IsActive" centered v-slot="props">
            {{ props.row.IsActive ? 'כן' : 'לא' }}
          </b-table-column>
          <b-table-column label="" centered v-slot="props">
            <div style="display: flex; gap: 6px; justify-content: center;">
              <b-button size="is-small" type="is-info" @click="openEditKey(props.row)">עריכה</b-button>
              <b-button size="is-small" type="is-danger" :loading="deletingKeyId === props.row.UserId" @click="confirmDeleteKey(props.row)">מחיקה</b-button>
            </div>
          </b-table-column>
          <template #empty>
            <div class="has-text-centered">אין מפתחות</div>
          </template>
        </b-table>
      </div>
      <div class="Profile__General__Page__Form__Field">
        <h3>הגדרות מערכת ניתור</h3>
        <b-table :data="model.ProfileTrackingProviders" :bordered="true" :striped="true" :narrowed="false"
          :hoverable="false">
          <b-table-column centered field="Id" label="סוג" v-slot="props">
            <b-select v-model="props.row.Type.Id" placeholder="בחר סוג">
              <option :value="1">איתוראן</option>
              <option :value="2">פויינטר</option>
            </b-select>
          </b-table-column>
          <b-table-column centered field="UserName" label="שם משתמש" v-slot="props">
            <b-input v-model="props.row.UserName"></b-input>
          </b-table-column>
          <b-table-column centered field="Password" label="סיסמה" v-slot="props" width="200">
            <b-input type="password" v-model="props.row.Password" password-reveal>
            </b-input>
          </b-table-column>
          <b-table-column centered field="IsActive" label="פעיל" v-slot="props">
            <b-switch v-model="props.row.IsActive">
              {{ props.row.IsActive ? "כן" : "לא" }}
            </b-switch>
          </b-table-column>
          <b-table-column centered field="IsActive" label="" v-slot="props">
            <b-button :loading="isSavingProfileTracking" @click="updateProfileTracking(props.row)" type="is-primary">
              עדכן
            </b-button>
          </b-table-column>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import ProfileService from "@/services/ProfileService";
import DialogProfileAppKey from "@/components/DialogProfileAppKey.vue";
import moment from "moment";

export default {
  name: "ProfileSettings",
  data() {
    return {
      isLoading: false,
       isSavingPassword: false,
       isUpdatingCheckDate: false,
       isSavingStartDate: false,
       isSavingProfileTracking: false,
       isAutomationLoading: false,
      IsOnNightRunning: null,
      appKeys: [],
      isLoadingKeys: false,
      deletingKeyId: null,
      model: {
        IsManaged: null,
        FineCenterPassword: null,
        ProfileTrackingProviders: [],
        IsInAutomation: null,
        IsInMileon: null,
        IsInMeitar: null,
        AllowRePortImport: null,
        DontShowMissingContractsTab: null,
        IsLeasingCompany: null,
         AllowManualChangeMenu: null,
         UsesValidDate: null,
         AllowClientFullReportVisibility: null,
         IsLocatedInRePortOnline: null,
         StartDate: null,
         LastCheckDate: null
      },
    };
  },
  computed: {
    ...mapGetters("profile", ["getProfileSettings"]),
    IsManaged() {
      return this.$store.state.profile.Settings.IsManaged;
    },
    isAdmin() {
      return this.$store.state.auth?.user?.claims?.isAdmin === "True";
    },
    IsInAutomation() {
      return this.$store.state.profile.Settings.IsInAutomation;
    },
    IsInMileon() {
      return this.$store.state.profile.Settings.IsInMileon;
    },
    IsInMeitar() {
      return this.$store.state.profile.Settings.IsInMeitar;
    },
    AllowRePortImport() {
      return this.$store.state.profile.Settings.AllowRePortImport;
    },
    DontShowMissingContractsTab() {
      return this.$store.state.profile.Settings.DontShowMissingContractsTab;
    },
    AllowManualChangeMenu() {
      return this.$store.state.profile.Settings.AllowManualChangeMenu;
    },
     UsesValidDate() {
       return this.$store.state.profile.Settings.UsesValidDate;
     },
     AllowClientFullReportVisibility() {
       return this.$store.state.profile.Settings.AllowClientFullReportVisibility;
     },
     IsLocatedInRePortOnline() {
       return this.$store.state.profile.Settings.IsLocatedInRePortOnline;
     },
     StartDate() {
       return this.$store.state.profile.Settings.StartDate;
     },
     LastCheckDate() {
       return this.$store.state.profile.Settings.LastCheckDate;
     },
  },
  created() {
    this.model = { ...this.model, ...this.getProfileSettings };

    // Ensure StartDate is loaded from store if not in getProfileSettings
    if (!this.model.StartDate && this.$store.state.profile.Settings.StartDate) {
      this.model.StartDate = this.$store.state.profile.Settings.StartDate;
    }

    // Format StartDate for HTML5 date input
    if (this.model.StartDate) {
      this.model.StartDate = this.formatDateForInput(this.model.StartDate);
    }

    ProfileService.getProfileAutomaticTransfer().then((res) => {
      this.IsOnNightRunning = res.data;
    }).catch((error) => {
      console.error('Error getting profile automatic transfer:', error);
      this.$buefy.toast.open({
        message: 'שגיאה: קרתה תקלה בקבלת סטטוס הסבה לילית',
        type: 'is-danger',
        duration: 5000
      });
    });
    if (this.isAdmin) {
      this.loadAppKeys();
    }
  },
  methods: {
    ...mapMutations("profile", ["setProfileSettings", "setProfile"]),

    async loadAppKeys() {
      const profileId = this.$store.state.profile.Id;
      if (!profileId) return;
      this.isLoadingKeys = true;
      try {
        const { data } = await ProfileService.getProfileAppKeys(profileId);
        this.appKeys = data;
      } catch {
        this.$buefy.toast.open({ type: 'is-danger', message: 'שגיאה בטעינת מפתחות API', duration: 5000 });
      } finally {
        this.isLoadingKeys = false;
      }
    },
    openAddKey() {
      const profileId = this.$store.state.profile.Id;
      this.$buefy.modal.open({
        component: DialogProfileAppKey,
        canCancel: false,
        hasModalCard: true,
        trapFocus: true,
        props: { profileId, keyData: null, onSuccess: this.loadAppKeys },
      });
    },
    openEditKey(row) {
      const profileId = this.$store.state.profile.Id;
      this.$buefy.modal.open({
        component: DialogProfileAppKey,
        canCancel: false,
        hasModalCard: true,
        trapFocus: true,
        props: { profileId, keyData: row, onSuccess: this.loadAppKeys },
      });
    },
    confirmDeleteKey(row) {
      this.$buefy.dialog.confirm({
        message: `האם אתה בטוח שברצונך למחוק את המפתח "${row.Name}"?`,
        confirmText: 'מחק',
        cancelText: 'בטל',
        type: 'is-danger',
        onConfirm: async () => {
          const profileId = this.$store.state.profile.Id;
          this.deletingKeyId = row.UserId;
          try {
            await ProfileService.deleteProfileAppKey(profileId, row.UserId);
            this.appKeys = this.appKeys.filter((k) => k.UserId !== row.UserId);
            this.showSuccessMessage();
          } catch {
            this.$buefy.toast.open({ type: 'is-danger', message: 'קרתה תקלה במחיקה', duration: 4000 });
          } finally {
            this.deletingKeyId = null;
          }
        },
      });
    },

    updateProfileTracking(row) {
      this.isSavingProfileTracking = true;
      ProfileService.updateProfileTracking(row.Id, row)
        .then(() => {
          this.setProfileSettings({
            ProfileTrackingProviders: this.model.ProfileTrackingProviders,
          });
          this.showSuccessMessage();
        })
        .catch((error) => {
          console.error('Error updating profile tracking:', error);
          this.$buefy.toast.open({
            message: 'שגיאה: קרתה תקלה בעדכון הפרופיל המערכתי',
            type: 'is-danger',
            duration: 5000
          });
        })
        .finally(() => {
          this.isSavingProfileTracking = false;
        });
    },
    savePassword() {
      this.isSavingPassword = true;
      ProfileService.setFineCenterPassword(this.model.FineCenterPassword)
        .then(() => {
          this.setProfileSettings({ FineCenterPassword: this.model.FineCenterPassword });
          this.isSavingPassword = false;
          this.showSuccessMessage();
        }
        )
        .catch((error) => {
          console.error('Error saving password:', error);
          this.$buefy.toast.open({
            message: 'שגיאה: קרתה תקלה בשמירת הסיסמה',
            type: 'is-danger',
            duration: 5000
          });
        });
    },
     updateCheckDate() {
       this.isUpdatingCheckDate = true;
       ProfileService.updateLastCheckDate()
         .then(() => {
           this.setProfileSettings({ LastCheckDate: moment(Date.now()) });
           this.isUpdatingCheckDate = false;
           this.showSuccessMessage();
         }
         )
         .catch((error) => {
          console.error('Error updating check date:', error);
          this.$buefy.toast.open({
            message: 'שגיאה: קרתה תקלה בעדכון התאריך האחרון',
            type: 'is-danger',
            duration: 5000
          });
          this.isUpdatingCheckDate = false;
        });
     },
    saveStartDate() {
      this.isSavingStartDate = true;
      // Convert the date to ISO format for the server, preserving the date without timezone conversion
      const dateToSave = this.model.StartDate ? moment(this.model.StartDate).format('YYYY-MM-DD') : null;
      ProfileService.setStartDate(dateToSave)
        .then(() => {
          this.setProfileSettings({ StartDate: this.model.StartDate });
          this.isSavingStartDate = false;
          this.showSuccessMessage();
        })
        .catch(() => {
          this.isSavingStartDate = false;
          this.$buefy.toast.open({
            type: "is-danger",
            message: "קרתה תקלה!",
            duration: 4000,
          });
        });
    },
    formatDateForInput(date) {
      if (!date) return null;
      // Convert to Date object for b-datepicker without timezone conversion
      if (typeof date === 'string') {
        // Parse the date string as local date to avoid timezone conversion
        const parts = date.split('T')[0].split('-');
        return new Date(parts[0], parts[1] - 1, parts[2]);
      }
      return date;
    },
     onStartDateChange(value) {
       // Handle date change from b-datepicker
       this.model.StartDate = value;
     },
    parseDate(date) {
      if (date) return moment(date).format("DD/MM/YYYY HH:mm");
      return '';
    },
    showSuccessMessage() {
      this.$buefy.toast.open({
        type: "is-success",
        message: "נשמר בהצלחה!",
        duration: 4000,
      });
    },
    onChangeActive() {
      const value = this.model.IsManaged;
      this.$buefy.dialog.confirm({
        message: `האם אתה בטוח שברצונך לשנות סטטוס ל${value ? "פעיל" : "לא פעיל"
          }?`,
        onConfirm: () => {
          ProfileService.setIsManaged(value).then(() => {
            this.setProfileSettings({ IsManaged: value });
            this.showSuccessMessage();
          }).catch((error) => {
            console.error('Error updating profile tracking:', error);
            this.$buefy.toast.open({
              message: 'שגיאה: קרתה תקלה בעדכון הפרופיל המערכתי',
              type: 'is-danger',
              duration: 5000
            });
          });
        },
        onCancel: () => {
          this.model.IsManaged = !value;
        },
        confirmText: "בטוח!",
        cancelText: "בטל",
      });
    },
    onChangeNightRunning() {
      const value = this.IsOnNightRunning;
      this.$buefy.dialog.confirm({
        message: `האם אתה בטוח שברצונך לשנות סטטוס של הסבה לילית ל${value ? "פעיל" : "לא פעיל"
          }?`,
        onConfirm: () => {
          this.isAutomationLoading = true;
          value ? ProfileService.addProfileAutomaticTransfer().then(() => {
            this.showSuccessMessage();
          }).catch(() => {
            this.IsOnNightRunning = !value;
            this.$buefy.toast.open({
              type: "is-danger",
              message: "קרתה תקלה!",
              duration: 4000,
            });
          }).finally(() => {
            this.isAutomationLoading = false;
          }) : ProfileService.deleteProfileAutomaticTransfer()
            .then(() => {
              this.showSuccessMessage();
            }).catch(() => {
              this.IsOnNightRunning = !value;
              this.$buefy.toast.open({
                type: "is-danger",
                message: "קרתה תקלה!",
                duration: 4000,
              });
            }).finally(() => {
              this.isAutomationLoading = false;
            });
        },
        onCancel: () => {
          this.IsOnNightRunning = !value;
        },
        confirmText: "בטוח!",
        cancelText: "בטל",
      });
    },
    onChangeAutomation() {
      const value = this.model.IsInAutomation;
      this.$buefy.dialog.confirm({
        message: `האם אתה בטוח שברצונך לשנות סטטוס ל${value ? "פעיל" : "לא פעיל"
          }?`,
        onConfirm: () => {
          this.isAutomationLoading = true;
          value ? ProfileService.addAutomation().then(() => {
            this.setProfileSettings({ IsInAutomation: value });
            this.showSuccessMessage();
          }).catch(() => {
            this.model.IsInAutomation = !value;
            this.$buefy.toast.open({
              type: "is-danger",
              message: "קרתה תקלה!",
              duration: 4000,
            });
          }).finally(() => {
            this.isAutomationLoading = false;
          }) : ProfileService.removeAutomation()
            .then(() => {
              this.setProfileSettings({ IsInAutomation: value });
              this.showSuccessMessage();
            }).catch(() => {
              this.model.IsInAutomation = !value;
              this.$buefy.toast.open({
                type: "is-danger",
                message: "קרתה תקלה!",
                duration: 4000,
              });
            }).finally(() => {
              this.isAutomationLoading = false;
            });
        },
        onCancel: () => {
          this.model.IsInAutomation = !value;
        },
        confirmText: "בטוח!",
        cancelText: "בטל",
      });
    },
    onChangeIsInMileon() {
      const value = this.model.IsInMileon;
      this.$buefy.dialog.confirm({
        message: `האם אתה בטוח שברצונך לשנות סטטוס ל${value ? "פעיל" : "לא פעיל"
          }?`,
        onConfirm: () => {
          this.isAutomationLoading = true;
          value ? ProfileService.addMileon().then(() => {
            this.setProfileSettings({ IsInMileon: value });
            this.showSuccessMessage();
          }).catch(() => {
            this.model.IsInMileon = !value;
            this.$buefy.toast.open({
              type: "is-danger",
              message: "קרתה תקלה!",
              duration: 4000,
            });
          }).finally(() => {
            this.isAutomationLoading = false;
          }) : ProfileService.removeMileon()
            .then(() => {
              this.setProfileSettings({ IsInMileon: value });
              this.showSuccessMessage();
            }).catch(() => {
              this.model.IsInMileon = !value;
              this.$buefy.toast.open({
                type: "is-danger",
                message: "קרתה תקלה!",
                duration: 4000,
              });
            }).finally(() => {
              this.isAutomationLoading = false;
            });
        },
        onCancel: () => {
          this.model.IsInMileon = !value;
        },
        confirmText: "בטוח!",
        cancelText: "בטל",
      });
    },
    onChangeIsInMeitar() {
      const value = this.model.IsInMeitar;
      this.$buefy.dialog.confirm({
        message: `האם אתה בטוח שברצונך לשנות סטטוס ל${value ? "פעיל" : "לא פעיל"
          }?`,
        onConfirm: () => {
          this.isAutomationLoading = true;
          value ? ProfileService.addMeitar().then(() => {
            this.setProfileSettings({ IsInMeitar: value });
            this.showSuccessMessage();
          }).catch(() => {
            this.model.IsInMeitar = !value;
            this.$buefy.toast.open({
              type: "is-danger",
              message: "קרתה תקלה!",
              duration: 4000,
            });
          }).finally(() => {
            this.isAutomationLoading = false;
          }) : ProfileService.removeMeitar()
            .then(() => {
              this.setProfileSettings({ IsInMeitar: value });
              this.showSuccessMessage();
            }).catch(() => {
              this.model.IsInMeitar = !value;
              this.$buefy.toast.open({
                type: "is-danger",
                message: "קרתה תקלה!",
                duration: 4000,
              });
            }).finally(() => {
              this.isAutomationLoading = false;
            });
        },
        onCancel: () => {
          this.model.IsInMeitar = !value;
        },
        confirmText: "בטוח!",
        cancelText: "בטל",
      });
    },
    onChangeAllowRePortImport() {
      const value = this.model.AllowRePortImport;
      this.$buefy.dialog.confirm({
        message: `האם אתה בטוח שברצונך לשנות סטטוס ל${value ? "פעיל" : "לא פעיל"
          }?`,
        onConfirm: () => {
          this.isAutomationLoading = true;
          value ? ProfileService.allowReport(true).then(() => {
            this.setProfileSettings({ AllowRePortImport: value });
            this.showSuccessMessage();
          }).catch(() => {
            this.model.AllowRePortImport = !value;
            this.$buefy.toast.open({
              type: "is-danger",
              message: "קרתה תקלה!",
              duration: 4000,
            });
          }).finally(() => {
            this.isAutomationLoading = false;
          }) : ProfileService.allowReport(false)
            .then(() => {
              this.setProfileSettings({ AllowRePortImport: value });
              this.showSuccessMessage();
            }).catch(() => {
              this.model.AllowRePortImport = !value;
              this.$buefy.toast.open({
                type: "is-danger",
                message: "קרתה תקלה!",
                duration: 4000,
              });
            }).finally(() => {
              this.isAutomationLoading = false;
            });
        },
        onCancel: () => {
          this.model.AllowRePortImport = !value;
        },
        confirmText: "בטוח!",
        cancelText: "בטל",
      });
    },
    onChangeDontShowMissingContractsTab() {
      const value = this.model.DontShowMissingContractsTab;
      this.$buefy.dialog.confirm({
        message: `האם אתה בטוח שברצונך לשנות סטטוס ל${value ? "פעיל" : "לא פעיל"
          }?`,
        onConfirm: () => {
          this.isAutomationLoading = true;
          value ? ProfileService.setDontShowMissingContractsTab(true).then(() => {
            this.setProfileSettings({ DontShowMissingContractsTab: value });
            this.showSuccessMessage();
          }).catch(() => {
            this.model.DontShowMissingContractsTab = !value;
            this.$buefy.toast.open({
              type: "is-danger",
              message: "קרתה תקלה!",
              duration: 4000,
            });
          }).finally(() => {
            this.isAutomationLoading = false;
          }) : ProfileService.setDontShowMissingContractsTab(false)
            .then(() => {
              this.setProfileSettings({ DontShowMissingContractsTab: value });
              this.showSuccessMessage();
            }).catch(() => {
              this.model.DontShowMissingContractsTab = !value;
              this.$buefy.toast.open({
                type: "is-danger",
                message: "קרתה תקלה!",
                duration: 4000,
              });
            }).finally(() => {
              this.isAutomationLoading = false;
            });
        },
        onCancel: () => {
          this.model.DontShowMissingContractsTab = !value;
        },
        confirmText: "בטוח!",
        cancelText: "בטל",
      });
    },
    onChangeIsLeasingCompany() {
      const value = this.model.IsLeasingCompany;
      this.$buefy.dialog.confirm({
        message: `האם אתה בטוח שברצונך לשנות ל${value ? "חברת ליסינג" : "לקוח קצה"
          }?`,
        onConfirm: () => {
          this.isAutomationLoading = true;
          ProfileService.setIsLeasingCompany(value).then(() => {
            this.setProfileSettings({ IsLeasingCompany: value });
            this.setProfile({ IsLeasingCompany: value });
            this.showSuccessMessage();
          }).catch(() => {
            this.model.IsLeasingCompany = !value;
            this.$buefy.toast.open({
              type: "is-danger",
              message: "קרתה תקלה!",
              duration: 4000,
            });
          }).finally(() => {
            this.isAutomationLoading = false;
          });
        },
        onCancel: () => {
          this.model.IsLeasingCompany = !value;
        },
        confirmText: "בטוח!",
        cancelText: "בטל",
      });
    },
    onChangeAllowManualChangeMenu() {
      const value = this.model.AllowManualChangeMenu;
      this.$buefy.dialog.confirm({
        message: `האם אתה בטוח שברצונך לשנות סטטוס ל${value ? "פעיל" : "לא פעיל"
          }?`,
        onConfirm: () => {
          this.isAutomationLoading = true;
          value ? ProfileService.setAllowManualChangeMenu(true).then(() => {
            this.setProfileSettings({ AllowManualChangeMenu: value });
            this.showSuccessMessage();
          }).catch(() => {
            this.model.AllowManualChangeMenu = !value;
            this.$buefy.toast.open({
              type: "is-danger",
              message: "קרתה תקלה!",
              duration: 4000,
            });
          }).finally(() => {
            this.isAutomationLoading = false;
          }) : ProfileService.setAllowManualChangeMenu(false)
            .then(() => {
              this.setProfileSettings({ AllowManualChangeMenu: value });
              this.showSuccessMessage();
            }).catch(() => {
              this.model.AllowManualChangeMenu = !value;
              this.$buefy.toast.open({
                type: "is-danger",
                message: "קרתה תקלה!",
                duration: 4000,
              });
            }).finally(() => {
              this.isAutomationLoading = false;
            });
        },
        onCancel: () => {
          this.model.AllowManualChangeMenu = !value;
        },
        confirmText: "בטוח!",
        cancelText: "בטל",
      });
    },
    onChangeUsesValidDate() {
      const value = this.model.UsesValidDate;
      this.$buefy.dialog.confirm({
        message: `האם אתה בטוח שברצונך לשנות סטטוס ל${value ? "פעיל" : "לא פעיל"
          }?`,
        onConfirm: () => {
          this.isAutomationLoading = true;
          value ? ProfileService.setUsesValidDate(true).then(() => {
            this.setProfileSettings({ UsesValidDate: value });
            this.showSuccessMessage();
          }).catch(() => {
            this.model.UsesValidDate = !value;
            this.$buefy.toast.open({
              type: "is-danger",
              message: "קרתה תקלה!",
              duration: 4000,
            });
          }).finally(() => {
            this.isAutomationLoading = false;
          }) : ProfileService.setUsesValidDate(false)
            .then(() => {
              this.setProfileSettings({ UsesValidDate: value });
              this.showSuccessMessage();
            }).catch(() => {
              this.model.UsesValidDate = !value;
              this.$buefy.toast.open({
                type: "is-danger",
                message: "קרתה תקלה!",
                duration: 4000,
              });
            }).finally(() => {
              this.isAutomationLoading = false;
            });
        },
        onCancel: () => {
          this.model.UsesValidDate = !value;
        },
        confirmText: "בטוח!",
        cancelText: "בטל",
      });
    },
    onChangeAllowClientFullReportVisibility() {
      const value = this.model.AllowClientFullReportVisibility;
      this.$buefy.dialog.confirm({
        message: `האם אתה בטוח שברצונך לשנות סטטוס ל${value ? "פעיל" : "לא פעיל"}?`,
        onConfirm: () => {
          this.isAutomationLoading = true;
          value ? ProfileService.setAllowClientFullReportVisibility(true).then(() => {
            this.setProfileSettings({ AllowClientFullReportVisibility: value });
            this.showSuccessMessage();
          }).catch(() => {
            this.model.AllowClientFullReportVisibility = !value;
            this.$buefy.toast.open({
              type: "is-danger",
              message: "קרתה תקלה!",
              duration: 4000,
            });
          }).finally(() => {
            this.isAutomationLoading = false;
          }) : ProfileService.setAllowClientFullReportVisibility(false)
            .then(() => {
              this.setProfileSettings({ AllowClientFullReportVisibility: value });
              this.showSuccessMessage();
            }).catch(() => {
              this.model.AllowClientFullReportVisibility = !value;
              this.$buefy.toast.open({
                type: "is-danger",
                message: "קרתה תקלה!",
                duration: 4000,
              });
            }).finally(() => {
              this.isAutomationLoading = false;
            });
        },
        onCancel: () => {
          this.model.AllowClientFullReportVisibility = !value;
        },
        confirmText: "בטוח!",
        cancelText: "בטל",
      });
    },
    onChangeIsLocatedInRePortOnline() {
      const value = this.model.IsLocatedInRePortOnline;
      this.$buefy.dialog.confirm({
        message: `האם אתה בטוח שברצונך לשנות סטטוס ל${value ? "פעיל" : "לא פעיל"}?`,
        onConfirm: () => {
          this.isAutomationLoading = true;
          value ? ProfileService.setIsLocatedInRePortOnline(true).then(() => {
            this.setProfileSettings({ IsLocatedInRePortOnline: value });
            this.showSuccessMessage();
          }).catch(() => {
            this.model.IsLocatedInRePortOnline = !value;
            this.$buefy.toast.open({
              type: "is-danger",
              message: "קרתה תקלה!",
              duration: 4000,
            });
          }).finally(() => {
            this.isAutomationLoading = false;
          }) : ProfileService.setIsLocatedInRePortOnline(false)
            .then(() => {
              this.setProfileSettings({ IsLocatedInRePortOnline: value });
              this.showSuccessMessage();
            }).catch(() => {
              this.model.IsLocatedInRePortOnline = !value;
              this.$buefy.toast.open({
                type: "is-danger",
                message: "קרתה תקלה!",
                duration: 4000,
              });
            }).finally(() => {
              this.isAutomationLoading = false;
            });
        },
        onCancel: () => {
          this.model.IsLocatedInRePortOnline = !value;
        },
        confirmText: "בטוח!",
        cancelText: "בטל",
      });
    },
  },
  watch: {
    IsManaged() {
      this.model = { ...this.model, ...this.getProfileSettings };
    },
    IsInAutomation() {
      this.model = { ...this.model, ...this.getProfileSettings };
    },
    IsInMileon() {
      this.model = { ...this.model, ...this.getProfileSettings };
    },
    IsInMeitar() {
      this.model = { ...this.model, ...this.getProfileSettings };
    },
    LastCheckDate() {
      this.model = { ...this.model, ...this.getProfileSettings };
    },
     IsOnNightRunning() {
       this.model = { ...this.model, ...this.getProfileSettings };
     },
     StartDate() {
       this.model = { ...this.model, ...this.getProfileSettings };
       // Format StartDate for HTML5 date input when it changes
       if (this.model.StartDate) {
         this.model.StartDate = this.formatDateForInput(this.model.StartDate);
       }
     },
  },
};
</script>
<style lang="scss" scoped>
.Profile__General__Page {
  padding: 20px 40px;

  .Profile__General__Page__Header {
    border-bottom: 1px solid silver;
    padding: 0px 10px 10px 10px;

    h1 {
      font-size: 30px;
    }
  }

  .Profile__General__Page__Form {
    margin-top: 20px;

    .Profile__General__Page__Form__Field {
      margin-top: 20px;

      .switch,
      .control {
        direction: ltr;
      }

      ::v-deep {
        .field label {
          font-size: 15px;
          color: rgb(44, 62, 80);
        }

        input {
          background-color: #f5f8fa;
          box-shadow: none;
          border: 1px solid #cbd6e2;

          &:focus {
            border: 2px solid #5fe0ea;
          }
        }
      }
    }

    .Profile__General__Page__Form__Actions {
      ::v-deep .button {
        margin-inline-end: 5px;
        background-color: #4d6884;
        color: white;
        border: none;
        border-radius: 3px;
        padding: 6px 15px;
        line-height: normal;
        height: unset;
        cursor: pointer;
        box-shadow: none;
        transition: transfrom 0.2s linear;

        &:hover {
          background-color: #54779c;
          border: none;
          outline: none;
        }

        &:active {
          transform: scale(0.98);
          border: none;
          outline: none;
        }
      }
    }
  }
}

/* RTL alignment for date picker */
::v-deep .is-rtl .datepicker input {
  text-align: right !important;
  direction: rtl !important;
}

::v-deep .is-rtl .datepicker .dropdown-menu {
  direction: rtl !important;
}

::v-deep .is-rtl .datepicker .input {
  text-align: right !important;
  direction: rtl !important;
}
</style>
